import AuthLoginOTM from "../../components/Auth/LoginOTM";

export default function Auth() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AuthLoginOTM/>
    </div>
  );
}
